import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=1bba320a&"
import script from "./Maintenance.vue?vue&type=script&lang=js&"
export * from "./Maintenance.vue?vue&type=script&lang=js&"
import style0 from "./Maintenance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Maintenance.vue"
export default component.exports